import { Theme } from "@mui/material";

export const imageContainerStyles = {
  width: "100%",
  maxWidth: { xs: 343, sm: 413, md: 523, lg: 615, xl: 758 },
};

export const sliderContainerStyles = {
  maxWidth: "100%",
  "& .swiper-slide": { display: "flex" },
};

export const slideStyles = {
  width: { xs: 343, md: 400, lg: 500, xl: 623 },
  height: { xs: 323, md: 376, lg: 476, xl: 585 },
  overflow: "hidden",
  boxSizing: "border-box",
  borderRadius: 5,
  padding: { xs: 5, md: 6, lg: 8, xl: 10 },
};

export const imageStyles = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};

export const getPaginationItemStyles = (
  theme: Theme,
  isActiveSlide: boolean
) => ({
  boxSizing: "border-box",
  width: { xs: 54, md: 99 },
  height: { xs: 50, md: 94 },
  minWidth: { xs: 54, md: 99 },
  minHeight: { xs: 50, md: 94 },
  padding: 0.5,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  border: `1px solid ${
    isActiveSlide ? theme.palette.primary.main : "transparent"
  }`,
  cursor: "pointer",
  borderRadius: 1,
});
